import { Component, DestroyRef, OnInit, inject } from "@angular/core";
import { environment } from "@environments/environment";
import { AuthPageRestoreService } from "@core/services/auth/auth-page-restore.service";
@Component({
  selector: "app-proxy",
  standalone: true,
  imports: [],
  templateUrl: "./proxy.component.html",
  styleUrls: ["./proxy.component.scss"],
})
export class ProxyComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private readonly authPageRestore = inject(AuthPageRestoreService);

  ngOnInit(): void {
    // Browser Back from /home can restore this document from bfcache without
    // re-bootstrapping Angular, leaving a stale "Connecting to the server..."
    // screen. Bounce straight back to /home when the session is still valid.
    this.authPageRestore.register(this.destroyRef);
    this.loadGigyaOIDC();
  }

  loadGigyaOIDC() {
    // Patch global error listener once to suppress external gigya script load errors in test env
    if (
      globalThis.window !== undefined &&
      !(globalThis.window as any).__gigyaScriptErrorPatched
    ) {
      (globalThis.window as any).__gigyaScriptErrorPatched = true;
      globalThis.addEventListener(
        "error",
        (ev: any) => {
          const tgt = ev?.target as HTMLScriptElement | undefined;
          if (
            tgt &&
            tgt?.tagName === "SCRIPT" &&
            tgt?.src.includes("gigya.oidc.js")
          ) {
            ev.stopImmediatePropagation?.();
            ev.preventDefault?.();
          }
        },
        true
      );
      const prevOnError = globalThis.onerror;
      globalThis.onerror = function (message, source, lineno, colno, error) {
        if (message === "Script error." || message === "Script error") {
          return true; // swallow
        }
        return prevOnError
          ? prevOnError(message, source, lineno, colno, error)
          : false;
      };
    }

    const node = document.createElement("script");
    node.src = `https://cdns.gigya.com/js/gigya.oidc.js?apiKey=${environment.apiKey}`;
    node.type = "text/javascript";
    node.lang = "javascript";
    const config = {
      loginURL: `${globalThis.location.origin}/login`,
      errorURL: `${globalThis.location.origin}/OpErrorPage`,
      skipConsent: true,
    };
    node.innerText = JSON.stringify(config);
    document.head.appendChild(node);
  }
}
